'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of checkmark
 */ const Checkmark = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "17.4297",
                y: "17.4297",
                width: "69.146",
                height: "69.146",
                rx: "34.1342",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M70.0586 38.286C71.131 39.4174 71.131 41.2548 70.0586 42.3862L48.0961 65.5571C47.0238 66.6885 45.2822 66.6885 44.2098 65.5571L33.5387 54.707C32.4663 53.5756 32.4663 51.7382 33.5387 50.6068C34.611 49.4754 36.3526 49.4754 37.425 50.6068L46.1573 59.4024L66.1808 38.286C67.2532 37.1547 68.9948 37.1547 70.0672 38.286H70.0586Z",
                fill: theme.ds5.asset[assetColor]["600"]
            })
        ]
    });
};

exports.Checkmark = Checkmark;
//# sourceMappingURL=Checkmark.cjs.map
